<template>
  <div
    v-if="preFooterSection && Object.keys(preFooterSection).length > 0"
    class="pre-footer-section"
  >
    <div class="pre-footer-section__wrap row-1">
      <div class="pre-footer-section__container p-top-5 p-bot-5">
        <div
          v-if="preFooterSection.sectionTitle"
          class="title-base title is-medium-bold"
          v-html="preFooterSection.sectionTitle"
        />
        <div
          v-if="preFooterSection.text"
          class="text-xsmall text"
          v-html="preFooterSection.text"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  preFooterSection: Object,
})
</script>

<script>
export default {
  name: 'PreFooterSection',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
